export enum ItemTypes {
    None = 0,
    Parent = 1,
    Package = 2,
    Group = 3,
    Service = 4,
    OrderSet = 5
}